import { gql } from '@apollo/client'

export const BILLING_ALLOWANCES = gql`
  query billingAllowances($kinds: [BillingAllowanceKind!]) {
    billingAllowances(kinds: $kinds) {
      allowances {
        kind
        total
        remaining
        allocated
      }
    }
  }
`
